<app-feature-list-container
  title="{{ '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.ECOTRONIC.TITLE' | translate }}"
  *ngrxLet="remoteConfigStore.isEcotronicAvailable$ as ecotronicRemoteFlag"
>
  <div class="feature-grid-container" viFeatureGrid viBorderBottom>
    <!-- heating.device.status -->
    <app-feature-list-item
      *ngIf="heatingDeviceStatus$ | async | ready as feature"
      data-at-device-status
      label="{{ '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.ECOTRONIC.STATUS' | translate }}:"
      [value]="feature.properties?.value?.value | translateHeatingDeviceStatus"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>

    <!-- heating.solar.status -->
    <app-feature-list-item
      *ngIf="solarStatus$ | async | ready as feature"
      data-at-solar-status
      label="{{ '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.ECOTRONIC.SOLAR_STATUS' | translate }}:"
      [value]="feature.properties?.value?.value | translateHeatingSolarStatus"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>

    <!-- heating.burners.0.manualActivation -->
    <ng-container *ngIf="burnerManualActivation$ | async | ready as burnerManualActivation">
      <ng-container
        *ngIf="
          !ecotronicRemoteFlag;
          then readonlyBurnerManualActivation;
          else editableBurnerManualActivation
        "
      ></ng-container>

      <!-- Readonly -->
      <ng-template #readonlyBurnerManualActivation>
        <app-feature-list-item
          data-at-activation-of-burner
          label="{{
            '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.ECOTRONIC.ACTIVATION_OF_BURNER' | translate
          }}:"
          [value]="
            burnerManualActivation.properties?.active?.value
              | booleanSuffix
                : [
                    customTranslationsService.ON_OFF_STATES.on | translate,
                    customTranslationsService.ON_OFF_STATES.off | translate
                  ]
          "
          [attr.data-feature]="burnerManualActivation.feature + '/active'"
        >
        </app-feature-list-item>
      </ng-template>

      <!-- Editable -->
      <ng-template #editableBurnerManualActivation>
        <app-feature-list-item
          data-at-activation-of-burner
          label="{{
            '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.ECOTRONIC.ACTIVATION_OF_BURNER' | translate
          }}:"
          [value]="
            burnerManualActivation.properties?.active?.value
              | booleanSuffix
                : [
                    customTranslationsService.ON_OFF_STATES.on | translate,
                    customTranslationsService.ON_OFF_STATES.off | translate
                  ]
          "
          [attr.data-feature]="burnerManualActivation.feature + '/active'"
          [isNgContent]="true"
          [editable]="true"
        >
          <mat-form-field
            mat-select-height-small
            class="ecotronic__form-field"
            gtm="onChange"
            gtmAction="Set target ppm concentration"
            gtmCategory="SRC air quality sensor panel"
          >
            <mat-select
              [value]="
                burnerManualActivation?.properties?.active?.value
                  | booleanSuffix
                    : [
                        customTranslationsService.ON_OFF_STATES.on | translate,
                        customTranslationsService.ON_OFF_STATES.off | translate
                      ]
              "
              (valueChange)="onBurnerManualActivationChange($event)"
              fieldTextContentTooltip
            >
              <mat-option
                *ngFor="let option of burnerManualActivationOptions"
                [value]="option | translate"
                fieldTextContentTooltip
              >
                {{ option | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </app-feature-list-item>
      </ng-template>
    </ng-container>

    <!-- heating.configuration.fuel.capacity -->
    <app-feature-list-item
      *ngIf="configurationFuelCapacity$ | async | ready as feature"
      data-at-fuel-tank-capacity
      label="{{
        '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.ECOTRONIC.FUEL_TANK_CAPACITY' | translate
      }}:"
      value="{{ feature | value2: featurePropertyKey.value }} {{ feature | unit: 'value' }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>

    <!-- heating.device.fuel.minimal -->
    <ng-container *ngIf="heatingDeviceFuelMinimal$ | async | ready as feature">
      <app-feature-list-item
        data-at-refill-feul-tank
        label="{{
          '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.ECOTRONIC.REFILL_FUEL_TANK' | translate
        }}:"
        value="{{ feature | value2: featurePropertyKey.value }} {{ feature | unit: 'value' }}"
        [attr.data-feature]="feature.feature"
        [editable]="feature | executable: featureCommands.setMinimalFilling"
        (edit)="openEditModal(FEATURE_NAMES.heatingDeviceFuelMinimal)"
      >
      </app-feature-list-item>
    </ng-container>

    <!-- heating.device.fuel.current -->
    <ng-container *ngIf="heatingDeviceFuelCurrent$ | async | ready as feature">
      <app-feature-list-item
        data-at-current-fuel-tank-value
        label="{{
          '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.ECOTRONIC.CURRENT_FUEL_TANK_VALUE' | translate
        }}:"
        value="{{ feature | value2: featurePropertyKey.value }} {{ feature | unit: 'value' }}"
        [attr.data-feature]="feature.feature"
      >
      </app-feature-list-item>
    </ng-container>

    <!-- heating.service.timeBased -->
    <app-feature-list-item
      *ngIf="serviceTimeBased$ | async | ready as feature"
      data-at-next-service-date
      label="{{
        '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.ECOTRONIC.NEXT_SERVICE_DATE' | translate
      }}:"
      [value]="feature.properties?.nextService?.value | date: 'short'"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>

    <!-- heating.service.burnerBased -->
    <ng-container *ngIf="serviceBurnerBased$ | async | ready as feature">
      <app-feature-list-item
        data-at-service-due
        label="{{
          '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.ECOTRONIC.SERVICE_DUE' | translate
        }}:"
        [value]="
          feature.properties?.serviceDue?.value
            | booleanSuffix
              : [
                  customTranslationsService.YES_NO_STATES.yes | translate,
                  customTranslationsService.YES_NO_STATES.no | translate
                ]
        "
        [attr.data-feature]="feature.feature + '/serviceDue'"
      >
      </app-feature-list-item>

      <app-feature-list-item
        data-at-burners-hours-till-next-service
        label="{{
          '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.ECOTRONIC.BURNERS_HOURS_TILL_NEXT_SERVICE'
            | translate
        }}:"
        value="{{ serviceBurnerBased | value2: featurePropertyKey.burnerHoursUntilNextService }} {{
          SUFFIX.hour
        }}"
        [attr.data-feature]="feature.feature + '/burnerHoursUntilNextService'"
      >
      </app-feature-list-item>
    </ng-container>
  </div>
</app-feature-list-container>
